import { mainApi } from "../../../../api";

export const userDataQuery = () => ({
    queryKey: ["userData"],
    queryFn: async () => mainApi.post("get_user_data"),
});
